import Button from '../base/Button';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <img 
              src="https://static.readdy.ai/image/807f7a13fa3a4707437af02957aa93c9/1baf6cd348ab623aee3f3ee6959ea81e.png" 
              alt="Mortgage Moat" 
              className="h-20 mb-4"
            />
            <p className="text-gray-300 mb-6 max-w-md">
              Protecting financial firms from cyber threats with industry-leading security solutions. 
              Get protected in 24 hours.
            </p>
            <div className="flex space-x-4">
              <Button variant="primary" size="sm" className="whitespace-nowrap" href="/pricing">
                Get Protected Now
              </Button>
              <Button variant="outline" size="sm" className="border-gray-600 text-gray-300 hover:bg-gray-800 whitespace-nowrap">
                Free Assessment
              </Button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Solutions</h4>
            <ul className="space-y-2">
              <li><a href="/risk-assessment" className="text-gray-300 hover:text-white">Security Risk Assessment</a></li>
              <li><a href="/managed-services" className="text-gray-300 hover:text-white">Managed Cyber Services</a></li>
              <li><a href="/awareness-training" className="text-gray-300 hover:text-white">Threat Awareness Training</a></li>
              <li><a href="#protection" className="text-gray-300 hover:text-white">24/7 Protection</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-red-500"></i>
                <a href="tel:+18446628277" className="text-gray-300 hover:text-white">844-662-8277</a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-red-500"></i>
                <a href="mailto:sales@mortgagemoat.com" className="text-gray-300 hover:text-white">sales@mortgagemoat.com</a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-red-500"></i>
                <span className="text-gray-300">24/7 Support</span>
              </li>
            </ul>
            <div className="flex gap-3 mt-4">
              <a href="https://www.facebook.com/mortgagemoat" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-colors">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="https://www.linkedin.com/company/mortgage-moat" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-colors">
                <i className="ri-linkedin-fill"></i>
              </a>
              <a href="https://www.instagram.com/mortgagemoat" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-colors">
                <i className="ri-instagram-fill"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm">
              © 2024 Mortgage Moat. All rights reserved.
            </div>
            <div className="flex items-center space-x-6 mt-4 md:mt-0">
              <a href="#privacy" className="text-gray-400 hover:text-white text-sm">Privacy Policy</a>
              <a href="#terms" className="text-gray-400 hover:text-white text-sm">Terms of Service</a>
              <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
